import { render, staticRenderFns } from "./channelPrecentage.vue?vue&type=template&id=8e158a18&scoped=true&"
import script from "./channelPrecentage.vue?vue&type=script&lang=js&"
export * from "./channelPrecentage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/bs-helpers.css?vue&type=style&index=0&id=8e158a18&lang=css&scoped=true&"
import style1 from "./channelPrecentage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e158a18",
  null
  
)

export default component.exports